angular
  .module('cfn')
  .controller('stockyardListController', stockyardListController);

stockyardListController.$inject = [
  '$scope',
  '$rootScope',
  '$log',
  '$timeout',
  '$http',
  '$location',
  'i18nFilter',
  'BookingOperations',
  'bookingRenderService',
  'storage',
  'timeZoneHackService'
];
function stockyardListController(
  $scope,
  $rootScope,
  $log,
  $timeout,
  $http,
  $location,
  i18nFilter,
  BookingOperations,
  bookingRenderService,
  storage,
  timeZoneHackService
) {
  // Model =================================================

  $scope.listData = {}; // filled by $scope.loadData()
  // Delegate Rendering to Service
  $scope.activityIconRenderer = bookingRenderService.activityIconRenderer;
  $scope.supplyRenderer = bookingRenderService.supplyRenderer;
  $scope.personRenderer = bookingRenderService.personRenderer;

  $scope.model = {
    year: null
  };

  // bind year to local storage
  storage.bind($scope, 'model.year', {
    defaultValue: new Date().getFullYear(),
    storeName: 'stockyardListYear'
  });

  // Functions ==============================================

  // Load Stockyard-Data from Server
  $scope.loadData = function() {
    app.startLoading(400);
    BookingOperations.query(
      {
        bookingYear: $scope.model.year,
        section: 'STOCKYARD'
      },
      function(operations) {
        app.finishLoading();
        $scope.listData = _.map(operations, function(operation) {
          operation.date = timeZoneHackService.toClientTimezone(operation.date);
          return operation;
        });
      }
    );
  };

  // Click in List -> jump und load data in mask
  $scope.cellClick = function(columnName, rowData) {
    var newLocation =
      '/booking/' + rowData.section.toLowerCase() + '/' + rowData.id;
    if (rowData.section === 'STOCKYARD') $location.path(newLocation);
    else
      app.gotoWithBackButton(
        newLocation,
        '/booking/stockyard/list', // backlink
        i18nFilter('fe.stockyard.list.back', 'zurück zur Lagerliste'), //
        'stockyardListController',
        {}
      );
  };

  // Init ====================================================

  // Load harvest years
  $http
    .get('/365FarmNet/rest/booking/harvestyears?section=STOCKYARD')
    .then(function(response) {
      let years = response.data;
      $scope.cropYears = _.sortBy(years, (val) => { return val; } ).reverse();
      // ensure that the selected year exists
      if (years.indexOf($scope.model.year) === -1)
        // if selected year is not a harvest year
        $scope.model.year = years[years.length - 1]; // select last harvest year
    });

  // react on year-change
  $scope.$watch('model.year', function() {
    $scope.loadData();
  });

  // Welcome back from booking
  if ($rootScope.goBackState && $rootScope.goBackState.type === 'stockyardListController') {
    $rootScope.alertController.closeAlert();
    $rootScope.goBackState = null;
  }
}
